/*
 * @Description: uuid
 * @Author: shangao
 * @Date: 2022-04-29 16:44:00
 * @LastEditTime: 2022-04-29 16:44:01
 * @LastEditors: shangao
 * @FilePath: \teaching-web\src\utils\uuid.js
 */
export default function uuid () {
  const str = URL.createObjectURL(new Blob())
  return str.substring(str.length - 36)
}